import { selectQueryString } from '@oneappexchange/lwc-wired';
import { getLastClickedUrl } from 'page/link';
import { i18nStore } from '../stores/i18nStore';
import { navigate, routerStore, selectMatch } from '../stores/routerStore';
export function scrollToTop() {
  var _document$querySelect;
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

  // eslint-disable-next-line @lwc/lwc/no-document-query
  (_document$querySelect = document.querySelector('#focus-reset')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.focus();
}
export function scrollToElement(selector, template) {
  const topDiv = template === null || template === void 0 ? void 0 : template.querySelector('[data-scroll-to="' + selector + '"]');
  if (topDiv) {
    topDiv.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'nearest'
    });
    const queryString = selectQueryString(routerStore.getState());
    const params = new URLSearchParams(queryString);
    params.delete('scrollTo');
    navigate(`${routerStore.getState().url}?${params}`);
  }
}
function beforeUnload(event) {
  const state = routerStore.getState();
  if (!this.isLoading && state.beforeUnload) {
    const returnValue = state.beforeUnload({
      ...selectMatch(state),
      url: getLastClickedUrl()
    });
    if (!returnValue) {
      return undefined;
    }
    const message = typeof returnValue === 'string' ? returnValue : returnValue === null || returnValue === void 0 ? void 0 : returnValue.message;
    if (!message) {
      return undefined;
    }
    event.preventDefault();
    return event.returnValue = message;
  }
  return undefined;
}
export function preventUnload(testCondition = () => true) {
  routerStore.setBeforeUnload(match => {
    if (match && (!testCondition || testCondition(match))) {
      return {
        message: i18nStore.getState().i18nStaticCache.shared.confirmDiscard,
        onClose: proceed => {
          // Fix URL that might have been changed when the back button was clicked
          if (!proceed) {
            const {
              url,
              queryString
            } = selectMatch(routerStore.getState());
            navigate(`${url}?${queryString}`);
          }
        }
      };
    }
    return undefined;
  });
  window.addEventListener('beforeunload', beforeUnload);
}
export function clearPreventUnload() {
  routerStore.setBeforeUnload();
  window.removeEventListener('beforeunload', beforeUnload);
}

// TODO: Replace native browser confirm with a custom confirm dialog
export async function confirmPrompt(message) {
  // eslint-disable-next-line no-alert,no-restricted-globals,no-return-await
  return await confirm(message);
}
export function createButtonKeyboardHandler(destinationOrCallback) {
  return function handleKeyboardButton(event) {
    if (event.code === 'Enter' || event.code === 'Space') {
      event.preventDefault();
      if (typeof destinationOrCallback === 'string') {
        navigate(destinationOrCallback);
      } else {
        destinationOrCallback(event);
      }
    }
  };
}
export function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}
export function getUniqueIteratorKey() {
  var _window, _window$crypto;
  return ((_window = window) === null || _window === void 0 ? void 0 : (_window$crypto = _window.crypto) === null || _window$crypto === void 0 ? void 0 : _window$crypto.randomUUID()) || (Math.random() + 1).toString(36).substring(7);
}
export function removeIteratorKeyFromState(state) {
  for (const prop in state) {
    if (prop === 'iteratorKey') {
      delete state[prop];
    } else if (typeof state[prop] === 'object') {
      removeIteratorKeyFromState(state[prop]);
    }
  }
  return state;
}
// Intended to be run as the callback funcion in an array's forEach
export function generateKeyForIterable(item) {
  if (item.iteratorKey === undefined) {
    item.iteratorKey = getUniqueIteratorKey();
  }
}

// Export private functions for testing purposes in test env
export const __test__ = process.env.NODE_ENV === 'test' ? {
  beforeUnload
} : {};